import { DeviceType } from 'app.configuration';
import { AppIdEnum } from 'cms/cms.configuration';
import { EcommerceBrandSettingsStradivarius } from 'idt-ecommerce-api/config/brandSettings.st';
import { RenderConfiguration } from 'render/render.configuration';


const CMSCTAPI_BASE_URL = 'https://www.stradivarius.com';
const STATIC_SERVER_BASE_URL = 'https://static.e-stradivarius.net/5/cms';
const STATIC_SERVER_BASE_URL_CN = 'https://static.stradivarius.cn/5/cms';


export const renderEnvironment: RenderConfiguration = {
  apiEcommerceBaseUrl: 'https://www.stradivarius.com/itxrest',
  isProduction: true,
  amandaImageVideoManagerEnabled: true,
  apiMaterializedUrl: `${CMSCTAPI_BASE_URL}/integration/cms/api/materialized`,
  ecommerce: {
    apiBaseUrl: `${CMSCTAPI_BASE_URL}/itxrest/2`,
    brandSettings: EcommerceBrandSettingsStradivarius,
    appId: AppIdEnum.web,
    catalogType: '1',
    instanceType: 'render',
    providers: {}
  },
  breakpoints: [
    {
      bp: '(min-width: 769px)',
      name: 'Desktop',
      device: [DeviceType.DESKTOP]
    },
    {
      bp: '(max-width: 768px)',
      name: 'Mobile',
      device: [DeviceType.MOBILE]
    }
  ],
  fonts: {
    sources: [
      {
        name: 'NeueHaasDisplayXXThin',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayXXThinItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayXThinItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayThin',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayThinItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayXThin',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayRomanItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayMediumItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayRoman',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayLightItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayMedium',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayBoldItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayLight',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayBlack',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayBlackItalic',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NeueHaasDisplayBold',
        path: '/fonts/neuehaasdisplay/'
      },
      {
        name: 'NotoSans-Regular',
        path: '/fonts/notosans/'
      },
      {
        name: 'NotoSans-Medium',
        path: '/fonts/notosans/'
      },
      {
        name: 'NotoSans-SemiBold',
        path: '/fonts/notosans/'
      },
      {
        name: 'NotoSans-Bold',
        path: '/fonts/notosans/'
      },
      {
        name: 'NotoSans-ExtraBold',
        path: '/fonts/notosans/'
      },
      {
        name: 'NotoSansArabic-Regular',
        path: '/fonts/notosansarabic/'
      },
      {
        name: 'NotoSansArabic-Medium',
        path: '/fonts/notosansarabic/'
      },
      {
        name: 'NotoSansArabic-SemiBold',
        path: '/fonts/notosansarabic/'
      },
      {
        name: 'NotoSansArabic-Bold',
        path: '/fonts/notosansarabic/'
      },
      {
        name: 'NotoSansArabic-ExtraBold',
        path: '/fonts/notosansarabic/'
      },
      {
        name: 'StrLogoSans',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSansRegular',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSansMedium',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSansSemiBold',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSansBold',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSerif',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSerifRegular',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSerifMedium',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSerifSemiBold',
        path: '/fonts/strss/'
      },
      {
        name: 'StrLogoSerifBold',
        path: '/fonts/strss/'
      },
      {
        name: 'STRADIVARIUSWEB2025-Regular',
        path: '/fonts/stradivariusweb2025/'
      },
      {
        name: 'STRADIVARIUSWEB2025-Medium',
        path: '/fonts/stradivariusweb2025/'
      },
      {
        name: 'STRADIVARIUSWEB2025-SemiBold',
        path: '/fonts/stradivariusweb2025/'
      },
      {
        name: 'STRADIVARIUSWEB2025-Bold',
        path: '/fonts/stradivariusweb2025/'
      },
      {
        name: 'STRADIVARIUSWEB2025-ExtraBold',
        path: '/fonts/stradivariusweb2025/'
      },
      {
        name: 'OpenSansLight',
        path: '/fonts/opensans/'
      },
      {
        name: 'OpenSansRegular',
        path: '/fonts/opensans/'
      },
      {
        name: 'OpenSansMedium',
        path: '/fonts/opensans/'
      },
      {
        name: 'OpenSansSemiBold',
        path: '/fonts/opensans/'
      },
      {
        name: 'OpenSansBold',
        path: '/fonts/opensans/'
      },
      {
        name: 'Oswald-ExtraLight',
        path: '/fonts/oswald/'
      },
      {
        name: 'Oswald-Light',
        path: '/fonts/oswald/'
      },
      {
        name: 'Oswald-Medium',
        path: '/fonts/oswald/'
      },
      {
        name: 'Oswald-Regular',
        path: '/fonts/oswald/'
      },
      {
        name: 'Oswald-SemiBold',
        path: '/fonts/oswald/'
      },
      {
        name: 'Oswald-Bold',
        path: '/fonts/oswald/'
      }
    ],
    domains: {
      default: STATIC_SERVER_BASE_URL,
      cn: STATIC_SERVER_BASE_URL_CN
    }
  },
  pageTypes: [
    {
      name: 'home',
      label: 'Home'
    }
  ]
};
